import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
  selector: 'app-core-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
  standalone: false
})
export class LoginPageComponent implements OnInit {
  loading = true;
  loginFailed = false;

  constructor(private oauthService: OAuthService, private router: Router) {
  }

  ngOnInit(): void {
    if (!(this.oauthService.hasValidIdToken() && this.oauthService.hasValidAccessToken())) {
      this.tryLogin();
      return;
    } 
    this.router.navigate(['/']);
  }

  tryLogin() {
    this.loading = true;
    this.loginFailed = false;
    this.oauthService.initLoginFlow();
  }
}
